import React, { useEffect } from 'react';
import GlobalWrapper from '../../components/Wrapper/GlobalWrapper';
import { Alert, Box, Button, Icon, Paper } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { getEngagementToken } from '../../redux/features/generalSlice';
import Loader3D from '../../components/Loader/Loader3D';

// SSO handoff into the Employee Engagement app (Triblast). Mirrors the CIMS /
// Grievance launchers: mint a short-lived handoff token, then open the app with
// ?sso=<token>, which the engagement app exchanges for a session (no re-login).
//
// IMPORTANT: we ALWAYS open with the token returned by the dispatch we just
// made — never with redux state. Redux may still hold the PREVIOUS user's
// handoff after a logout/login (generalSlice isn't cleared on logout), which
// used to open the previous user's engagement session. Handoffs are also
// single-use, so every open mints a fresh one.
const engagementUrl = process.env.REACT_APP_ENGAGEMENT_URL || 'http://localhost:3001';

export default function EngagementLanding() {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.general.engagementToken.data);
  const loading = useSelector((state) => state.general.engagementToken.loading);

  const mintAndOpen = () =>
    dispatch(getEngagementToken({ module: 'engagement', expiresIn: '5m' })).then((action) => {
      const fresh = action?.payload?.data;
      if (fresh) window.open(`${engagementUrl}?sso=${fresh}`);
    });

  useEffect(() => {
    mintAndOpen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <GlobalWrapper title="Triblast — Employee Engagement">
      {loading && <Loader3D />}
      {token && !loading && (
        <Paper elevation={6} sx={{ p: 3 }}>
          <Button
            endIcon={<Icon icon="ix:goto" width="25" height="25" style={{ color: '#41e20f' }} />}
            sx={{ boxShadow: 'none', px: 2 }}
            variant="outlined"
            color="success"
            onClick={mintAndOpen}
          >
            Open Triblast
          </Button>
        </Paper>
      )}
      {!token && !loading && (
        <Paper elevation={6} sx={{ p: 1, textAlign: 'center' }}>
          <Box sx={{ textAlign: 'center', fontSize: 20 }}>
            <Alert severity="error">Something went wrong, please try again later.</Alert>
          </Box>
          <Button
            variant="outlined"
            color="error"
            onClick={mintAndOpen}
            sx={{
              my: 2,
              px: 4,
              borderRadius: '30px',
              fontWeight: 600,
              textTransform: 'none',
              boxShadow: 'none',
            }}
          >
            Retry
          </Button>
        </Paper>
      )}
    </GlobalWrapper>
  );
}
